import { useMutation } from "@apollo/client";
import { Button, Flex, useToast } from "@chakra-ui/react";
import ModalWrapper from "../../components/modals/ModalWrapper";
import { setAuthToken } from "../../utils/token";
import LoginForm from "./LoginForm";
import { LOGIN } from "./mutations";
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { useAuth } from "../../context/AuthContext";
import { Helmet } from "react-helmet";
import { ArrowBackIcon } from "@chakra-ui/icons";

type LoginProps = {};

const Login = (props: LoginProps) => {
  const formName = "createUserForm";
  const toast = useToast();

  const navigate = useNavigate();
  const { setAuth } = useAuth();

  const [userLogin, { loading }] = useMutation(LOGIN);
  const onSubmit = async ({ username, password }: any) => {
    try {
      const { data } = await userLogin({
        variables: {
          username,
          password,
        },
      });
      if (!loading && data) {
        if (data.login.access_token) {
          await setAuthToken(data.login.access_token);
          const auth: any = jwtDecode(data.login.access_token);
          setAuth(auth);
          if (auth) {
            navigate("/dashboard");
          }
        }
      }
    } catch (error: any) {
      if (!toast.isActive("active-toast")) {
        toast({
          id: "active-toast",
          title: error.message,
          status: "error",
          duration: 4000,
          isClosable: true,
          variant: "solid",
        });
      }
    }
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgGradient="linear-gradient(312deg, white 50%, primary 50%)"
    >
      <Helmet>
        <title>Freeshu | Login</title>
      </Helmet>
      <ModalWrapper
        withOverlay={false}
        withCloseButton={false}
        isOpen={true}
        onClose={() => {}}
        size="sm"
        isCentered={true}
      >
        <Flex
          flexDirection="column"
          my="auto"
          justifyContent="center"
          p="4"
          py="7"
        >
          <LoginForm
            formName={formName}
            onSubmit={onSubmit}
            initialValues={{
              username: "surigao_public_market@freeshu",
              password: "surigao_public_market@freeshu",
            }}
          />
          <Button
            bg={"primary"}
            color={"white"}
            textAlign="center"
            mt="5"
            _hover={{
              bg: "green.500",
            }}
            type="submit"
            form={formName}
            isLoading={loading}
          >
            Login
          </Button>

          <Button
            as={Link}
            to="/"
            color={"primary"}
            variant="link"
            textAlign="center"
            mt="5"
            leftIcon={<ArrowBackIcon />}
          >
            Home
          </Button>
        </Flex>
      </ModalWrapper>
    </Flex>
  );
};

export default Login;
